module.exports = __webpack_public_path__ + "img/bn.6174f291.png";